import { OnInit, AfterViewInit, Component, Input, Output, EventEmitter } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import { GraphService } from "src/app/services/graphs.service";
import { MessageService } from "src/app/services/message.service";
import { ConfigModel, FinGearingModel } from "src/app/models/graphs.model";
import { Observable } from "rxjs";

@Component({
    selector: 'app-fin-gearing',
    templateUrl: './gearing.component.html',
    styleUrls: ['../../home/home.component.scss']
})

export class GearingComponent implements OnInit, AfterViewInit {

    graphService: Observable<any>;
    graphData: ConfigModel = new ConfigModel();
    finChart: Object;
    finInitialGearingQuarterYear: string[];

    @Input() fin_Gearing_Name1: string;
    @Input() fin_Gearing_Name2: string;
    @Input() fin_Gearing_Name3: string;
    @Input() fin_Gearing_Name4: string;
    @Input() fin_Gearing_1: number;
    @Input() fin_Gearing_2: number;
    @Input() fin_Gearing_3: number;
    @Input() fin_Gearing_4: number;
    @Input() fin_Gearing_Max: number;

    finGearingInitialQuarter: number;
    @Input() finGearingInitialYear: number;
    @Output() fin_Gearing_Quarter = new EventEmitter();
    @Output() fin_Gearing_Year = new EventEmitter();

    @Output() GearingName1 = new EventEmitter();
    @Output() GearingName2 = new EventEmitter();
    @Output() GearingName3 = new EventEmitter();
    @Output() GearingName4 = new EventEmitter();

    constructor(private globals: GlobalService,
        private graph: GraphService,
        private messageService: MessageService) {
        this.graphData = new ConfigModel();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.load();
        })
    }

    ngOnInit(): void {
    }

    load() {

        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;
            this.finInitialGearingQuarterYear = this.graphData.fin_Gearing_Name1.split(" ");
            this.finGearingInitialQuarter = parseInt(this.finInitialGearingQuarterYear[0].slice(1, 3));
            this.finGearingInitialYear = parseInt(this.finInitialGearingQuarterYear[1]);
            this.fin_Gearing_Quarter.emit(this.finGearingInitialQuarter);
            this.fin_Gearing_Year.emit(this.finGearingInitialYear);

            this.finGearingGraph();
        });
    }

    changeQuarter(quarter) {

        this.finGearingInitialQuarter = quarter;
        this.switchQuarter();

        this.GearingName1.emit(this.graphData.fin_Gearing_Name1);
        this.GearingName2.emit(this.graphData.fin_Gearing_Name2);
        this.GearingName3.emit(this.graphData.fin_Gearing_Name3);
        this.GearingName4.emit(this.graphData.fin_Gearing_Name4);
    }

    changeYear(year) {

        this.finGearingInitialYear = year;
        this.switchQuarter();
        this.GearingName1.emit(this.graphData.fin_Gearing_Name1);
        this.GearingName2.emit(this.graphData.fin_Gearing_Name2);
        this.GearingName3.emit(this.graphData.fin_Gearing_Name3);
        this.GearingName4.emit(this.graphData.fin_Gearing_Name4);
    }

    refresh() {

        this.switchQuarter();

        this.graphData.fin_Gearing_1 = this.fin_Gearing_1;
        this.graphData.fin_Gearing_2 = this.fin_Gearing_2;
        this.graphData.fin_Gearing_3 = this.fin_Gearing_3;
        this.graphData.fin_Gearing_4 = this.fin_Gearing_4;
        this.graphData.fin_Gearing_Max = this.fin_Gearing_Max;

        var x1 = this.graphData.fin_Gearing_1;
        var y1: number = +x1;
        this.graphData.fin_Gearing_1 = y1;

        var x2 = this.graphData.fin_Gearing_2;
        var y2: number = +x2;
        this.graphData.fin_Gearing_2 = y2;

        var x3 = this.graphData.fin_Gearing_3;
        var y3: number = +x3;
        this.graphData.fin_Gearing_3 = y3;

        var x4 = this.graphData.fin_Gearing_4;
        var y4: number = +x4;
        this.graphData.fin_Gearing_4 = y4;

        var x5 = this.graphData.fin_Gearing_Max;
        var y5: number = +x5;
        this.graphData.fin_Gearing_Max = y5;

        this.finGearingGraph();

        this.GearingName1.emit(this.graphData.fin_Gearing_Name1);
        this.GearingName2.emit(this.graphData.fin_Gearing_Name2);
        this.GearingName3.emit(this.graphData.fin_Gearing_Name3);
        this.GearingName4.emit(this.graphData.fin_Gearing_Name4);
    }

    saveFGearingData() {

        this.globals.hasLoaded = false;

        let finGearingModel: FinGearingModel = new FinGearingModel();
        finGearingModel.gearing_Name1 = this.fin_Gearing_Name1;
        finGearingModel.gearing_Name2 = this.fin_Gearing_Name2;
        finGearingModel.gearing_Name3 = this.fin_Gearing_Name3;
        finGearingModel.gearing_Name4 = this.fin_Gearing_Name4;
        finGearingModel.gearing_1 = this.fin_Gearing_1;
        finGearingModel.gearing_2 = this.fin_Gearing_2;
        finGearingModel.gearing_3 = this.fin_Gearing_3;
        finGearingModel.gearing_4 = this.fin_Gearing_4;
        finGearingModel.gearing_Max = this.fin_Gearing_Max;

        let jsonObject: any = JSON.stringify(finGearingModel);

        this.graphService = this.graph.postFinGearing(jsonObject);

        this.graphService.subscribe(data => {

            this.globals.hasLoaded = true;
            setTimeout(() => {
                this.messageService.sendSuccessMessage("Saved Financial Sales Revenue Data Successfully");
            }, 200)
            // this.router.navigate(['/']);
        }, err => {
            console.log(err);
            this.globals.hasLoaded = true;
            let msg = "Error saving Financial Sales Revenue details";
            if (err.message != undefined)
                msg += ': ' + err.message;
            this.messageService.sendErrorMessage(msg);
        });
    }

    switchQuarter() {

        let assignedYear = this.finGearingInitialYear;

        if (this.finGearingInitialQuarter == 1) {

            this.graphData.fin_Gearing_Name1 = "Q1" + " " + assignedYear;
            this.graphData.fin_Gearing_Name2 = "Q2" + " " + assignedYear;
            this.graphData.fin_Gearing_Name3 = "Q3" + " " + assignedYear;
            this.graphData.fin_Gearing_Name4 = "Q4" + " " + assignedYear;
        } else if (this.finGearingInitialQuarter == 2) {

            this.graphData.fin_Gearing_Name1 = "Q2" + " " + assignedYear;
            this.graphData.fin_Gearing_Name2 = "Q3" + " " + assignedYear;
            this.graphData.fin_Gearing_Name3 = "Q4" + " " + assignedYear;
            this.graphData.fin_Gearing_Name4 = "Q1" + " " + (++assignedYear);
        } else if (this.finGearingInitialQuarter == 3) {

            this.graphData.fin_Gearing_Name1 = "Q3" + " " + assignedYear;
            this.graphData.fin_Gearing_Name2 = "Q4" + " " + assignedYear;
            this.graphData.fin_Gearing_Name3 = "Q1" + " " + (++assignedYear);
            this.graphData.fin_Gearing_Name4 = "Q2" + " " + assignedYear;
        } else if (this.finGearingInitialQuarter == 4) {

            this.graphData.fin_Gearing_Name1 = "Q4" + " " + assignedYear;
            this.graphData.fin_Gearing_Name2 = "Q1" + " " + (++assignedYear);
            this.graphData.fin_Gearing_Name3 = "Q2" + " " + assignedYear;
            this.graphData.fin_Gearing_Name4 = "Q3" + " " + assignedYear;
        }
    }

    finGearingGraph() {

        this.finChart = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "line",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#90a4ae",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            title: {
                text: 'Gearing',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                categories: [this.graphData.fin_Gearing_Name1,
                this.graphData.fin_Gearing_Name2, this.graphData.fin_Gearing_Name3, this.graphData.fin_Gearing_Name4],
            },
            yAxis: [{
                title: {
                    text: '%',
                    // style: {
                    //     fontFamily: "Verdana",
                    //     fontSize: "18px",
                    //     fontWeight: "normal",
                    //     fontStyle: "normal"
                    // }
                },
                // min: 15, 
                // max: this.graphData.fin_Gearing_Max, 
                tickInterval: 5,
                minorTickInterval: 5,
                majorTickInterval: 5,
                gridLineWidth: 0,
                labels: {
                    formatter: function () {
                        return this.value;
                    }
                }
            }],

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                enabled: false
            },

            // plotOptions: {
            //     line: {
            //         dataLabels: {
            //             enabled: false
            //         },
            //         enableMouseTracking: false
            //     },
            //     spline: {
            //         marker: {
            //             radius: 4,
            //             lineColor: '#666666',
            //             lineWidth: 1,

            //         }
            //     }
            // },
            tooltip: {
                outside: true
            },

            // series: [{
            //     name: '',
            //     showInLegend: false,  
            //     data: [20, 20, 20, 20]
            // }],

            series: [{
                showInLegend: false,
                name: 'Gearing',
                data: [this.graphData.fin_Gearing_1, this.graphData.fin_Gearing_2, this.graphData.fin_Gearing_3, this.graphData.fin_Gearing_4],
            }],

            colors: ["#58a1d8"],
        };
    }
}